import type { ReactNode } from "react";

import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

type LabelWithTooltipProps = {
    label: ReactNode;
    tooltipContent: ReactNode;
};

export const LabelWithTooltip = ({ label, tooltipContent }: LabelWithTooltipProps) => (
    <Flex
        gap="8px"
        alignItems="center"
    >
        <span>{label}</span>
        <Tooltip content={tooltipContent}>
            <Info24px
                size="sm"
                color={colorsPalettes.carbon[300]}
            />
        </Tooltip>
    </Flex>
);
